import * as yup from 'yup';

export const formSchema = yup.object().shape({
  firstName: yup
    .string()
    .max(50, 'First name is too long')
    .required('First name is required')
    .default(''),
  lastName: yup
    .string()
    .max(50, 'Last name is too long')
    .required('Last name is required')
    .default(''),
  email: yup
    .string()
    .email('Invalid email')
    .required('Email is required')
    .default(''),
  password: yup
    .string()
    .min(8, 'Password must be at least 8 characters long')
    .required('Password is required')
    .default(''),
});

export type FormSchema = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  captchaToken?: string;
};

export const initialValues: FormSchema = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  captchaToken: undefined,
};
